var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"pt-4"},[_c('div',{staticClass:"d-flex"},[_c('listarGrupos'),_c('div',{staticClass:"position-relative",staticStyle:{"width":"calc(100vw - 489px)"}},[_c('mapa-geocercas')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }